var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M10.767 6.47H.42c-.309 0-.427-.37-.17-.525L5.072 3.06 9.69.294c.655-.392 1.5-.392 2.155 0l4.618 2.765 4.82 2.886c.26.155.14.524-.168.524H10.767z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6D5990",
    d: "M12.09 3.364c0 .754-.61 1.364-1.363 1.364-.754 0-1.364-.61-1.364-1.364 0-.752.61-1.362 1.364-1.362.752 0 1.362.61 1.362 1.362"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3C2F0",
    d: "M2.062 7.486c-.316 0-.572.256-.572.572v7.726c0 .315.256.571.572.571h2.06V10.52c0-.716.58-1.297 1.296-1.297h.019c.716 0 1.297.581 1.297 1.297v5.835h2.758V10.52c0-.716.58-1.297 1.297-1.297h.02c.716 0 1.296.581 1.296 1.297v5.835h2.63V10.52c0-.716.581-1.297 1.298-1.297h.02c.716 0 1.296.581 1.296 1.297v5.835h1.936c.374 0 .677-.303.677-.677v-7.62c0-.316-.256-.572-.571-.572H2.062z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9494ED",
    d: "M1.058 17.155h19.2c.584 0 1.058.474 1.058 1.058v.948H0v-.948c0-.584.474-1.058 1.058-1.058"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.2340f6f40942ba83be6db38633c0a7df.svg";
export { ForwardRef as ReactComponent };